import { render, staticRenderFns } from "./InformativeMosaicItem.vue?vue&type=template&id=3639c524&scoped=true&"
import script from "./InformativeMosaicItem.vue?vue&type=script&lang=js&"
export * from "./InformativeMosaicItem.vue?vue&type=script&lang=js&"
import style0 from "./InformativeMosaicItem.vue?vue&type=style&index=0&id=3639c524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3639c524",
  null
  
)

export default component.exports